import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lead } from "../types";

interface EditLeadDialogProps {
  isOpen: boolean;
  onClose: () => void;
  lead: Lead;
  editedLead: Lead;
  setEditedLead: (lead: Lead) => void;
  onSubmit: () => void;
}

export const EditLeadDialog = ({
  isOpen,
  onClose,
  lead,
  editedLead,
  setEditedLead,
  onSubmit
}: EditLeadDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Lead</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Input
                placeholder="First Name"
                value={editedLead.first_name}
                onChange={(e) => setEditedLead({ ...editedLead, first_name: e.target.value })}
              />
            </div>
            <div>
              <Input
                placeholder="Last Name"
                value={editedLead.last_name}
                onChange={(e) => setEditedLead({ ...editedLead, last_name: e.target.value })}
              />
            </div>
          </div>
          <div>
            <Input
              type="email"
              placeholder="Email"
              value={editedLead.email}
              onChange={(e) => setEditedLead({ ...editedLead, email: e.target.value })}
            />
          </div>
          <div>
            <Input
              placeholder="Phone"
              value={editedLead.phone}
              onChange={(e) => setEditedLead({ ...editedLead, phone: e.target.value })}
            />
          </div>
          <div>
            <Input
              placeholder="Insurance Type"
              value={editedLead.insurance_type}
              onChange={(e) => setEditedLead({ ...editedLead, insurance_type: e.target.value })}
            />
          </div>
          <div>
            <Input
              type="number"
              placeholder="Quoted Amount"
              value={editedLead.quoted_amount}
              onChange={(e) => setEditedLead({ ...editedLead, quoted_amount: Number(e.target.value) })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit}>
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};